module.exports = __webpack_public_path__ + "static/media/maxima.c6761c28.png";